import { createFileRoute, redirect } from "@tanstack/react-router";

/** Sammanslagen med elavtalssidan – permanent omdirigering. */
export const Route = createFileRoute("/elpriser/rorligt")({
  beforeLoad: () => {
    throw redirect({ to: "/elavtal/rorligt", statusCode: 301 });
  },
});
